import { ConsentType } from "@imprivata-cloud/authn";
import { CheckDpaConsentResponseActionType, type SelfServiceLandingPageDataResponse, type ConsentInfo } from "../../api/types";
import { ConsentGrantType } from "../../api/constants";

export const consentNeeded = (consentInfo: ConsentInfo) => {
    return consentInfo.grantType === ConsentGrantType.NOT_GRANTED ||
        consentInfo.actionType === CheckDpaConsentResponseActionType.CHECK_NEEDED ||
        consentInfo.actionType === CheckDpaConsentResponseActionType.UPDATE_NEEDED;
}

export const faceEnrolled = (data: SelfServiceLandingPageDataResponse) => {
    return data.authenticators?.find(info => info.factorType === "face")
}
export const getBiometricsConsentInfo = (data?: SelfServiceLandingPageDataResponse) => {
    return data?.consentInfos?.find(info => info.consentType === ConsentType.BIOMETRICS,
    );
}
